import { lazy } from "react"

export const Payments = lazy(() => import("views/payments/Index"))
export const PaymentFormModal = lazy(() => import("views/payments/components/PaymentFormModal"))
export const PaymentsDataGrid = lazy(() => import("components/paymentsDataGrid/PaymentsDataGrid"))
